export const GLOBAL_STATE = 'ModuleFile'

export const MODULE_FILE = 'moduleFile'
export const MODULE_FILE_LIST = 'moduleFileList'
export const MODULE_FILE_ALL = 'moduleFileAll'
export const MODULE_FILE_CREATE = 'moduleFileCreate'
export const MODULE_FILE_DELETE = 'moduleFileDelete'
